<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column">
        <div class="card flex-1-auto h-100 overflow-auto">
          <div class="card-header card-header-with-button">
               <h5>{{$t('BUILDINGDETAILS')}}</h5>
               <button type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
            </div>
            <div class="card-body" v-if="globals && globals.groupId != 8">
              <div class="row">
                <div class="col-12">
                  <div class="flex-0-auto mb-3" v-if="(globals && globals.acl && globals.acl.Job && globals.acl.Job.insertAction) ? true : false">
                    <div class="buttons-group">
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <span>{{$t('CLIENTNAME')}}</span>
                              <input class="form-control" placeholder=" " v-model="paginationSec.clientName">
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <span>{{$t('ADDRESS')}}</span>
                              <input class="form-control" placeholder=" " v-model="paginationSec.address">
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <span>{{$t('CITY')}}</span>
                              <input class="form-control" placeholder=" " v-model="paginationSec.city">
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <button type="button" class="btn-bis btn-tertiary mtt-2" @click="getData()"><!--icon icon="search"></icon-->{{$t('SEARCH')}}</button>
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <button type="button" class="btn-bis btn-tertiary mtt-2" @click="$refs.csvexportmodal.show()"><!--icon icon="search"></icon-->{{$t('DOWNLOADCSV')}}</button>
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <button type="button" class="btn-bis btn-tertiary mtt-2" @click="$refs.csvimportmodal.show()"><!--icon icon="search"></icon-->{{$t('IMPORTCSV')}}</button>
                          </b-form-fieldset>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                    <th></th>
                    <th>{{$t('OBJECTID')}}</th>
                    <th>{{$t('CLIENTNAME')}}</th>
                    <th>{{$t('ADDRESS')}}</th>
                    <th>{{$t('POSTALCODE')}}</th>
                    <th>{{$t('CITY')}}</th>
                    <th>{{$t('CONTACTPERSON')}}</th>
                    <th>{{$t('EMAIL')}}</th>
                    <th>{{$t('PHONE')}}</th>
                    <th>{{$t('OBJECTDETAILS')}}</th>
                    <th>{{$t('ACTIONS')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in data.root">
                    <tr :key="item.buildingDetailId" aria-rowindex="1" class=" table-ellipsis">
                        <td>
                            <icon v-if="item.showAditionalData != null && item.showAditionalData == true" icon="arrow-up" @click="hideRow(item)"></icon>
                            <icon v-else icon="arrow-down" @click="showRow(item)"></icon>
                        </td>
                        <td>{{item.objectId}}</td>
                        <td>{{item.clientName}}</td>
                        <td>{{item.address}}</td>
                        <td>{{item.postalCode}}</td>
                        <td>{{item.city}}</td>
                        <td>{{item.contactPerson}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.phone}}</td>
                        <td>{{item.objectDetails}}</td>
                        <td class="table-buttons">
                          <b-button type="reset" class="btn-table table-btn-secondary"  @click="copy(item.buildingDetailId)">{{$t('COPY')}}</b-button>
                          <b-button type="reset" class="btn-table table-btn-tertiary ml-2" @click="showModal(item)">{{$t('EDIT')}}</b-button>
                          <b-button type="reset" class="btn-table table-btn-delete ml-2" @click="deleteRow(item.buildingDetailId)">{{$t('DELETE')}}</b-button>
                        </td>
                    </tr>
                    <tr v-if="item.showAditionalData != null && item.showAditionalData == true" v-for="itemSec in item.checlList" :key="`${itemSec.checkListItemId}_${item.buildingDetailId}`">
                        <td></td>
                        <td>
                            <b-form-checkbox :checked="itemSec.isChecked" :value="1" :unchecked-value="0" @change="changeStatus($event, itemSec.checkListItemId, item.buildingDetailId)"></b-form-checkbox>
                        </td>
                        <td>{{itemSec.name}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <pagination
                v-bind:totalCount="data.totalCount"
                v-model="pagination">
            </pagination>
          </div>
        </div>
    </div>
    <buildingdetailform v-model="formData" v-on:close="formData = null; getData()"></buildingdetailform>
    <b-modal ref="csvexportmodal" centered :title="$t('CSVEXPORT')" ok-title="submit" hide-footer>
        <div class="d-block mt-2 modal-content-inside">
            <div role="group" class="b-form-group form-group">
                <div class="form-row" v-if="globals && globals.acl && globals.acl.UserCompanies && globals.acl.UserCompanies.insertAction">
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('SHOWHEADERFIELDS')">
                            <b-form-checkbox
                            v-model="formExport.showHeaderFields"
                            :value="1"
                            :unchecked-value="0">{{$t('SHOWHEADERFIELDS')}}</b-form-checkbox>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('SEPARATOR')">
                            <select class="form-control" v-model="formExport.separator">
                                <option value=",">{{$t('COMMA')}}</option>
                                <option value=";">{{$t('DOTCOMMA')}}</option>
                            </select>
                        </b-form-fieldset>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center mt-lg mb-lg">
            <b-btn class="mr-2 btn-bis btn-cancel" @click="$refs.csvexportmodal.hide()">{{$t('CANCEL')}}</b-btn>
            <b-btn class="btn-bis btn-primary" v-on:click.prevent="downloadCsv(); $refs.csvexportmodal.hide();">{{$t('EXPORT')}}</b-btn>
        </div>
    </b-modal>
    <b-modal ref="csvimportmodal" centered :title="$t('CSVIMPORT')" ok-title="submit" hide-footer @close="closeImport()">
        <div class="d-block mt-2 modal-content-inside">
            <div role="group" class="b-form-group form-group">
                <div class="form-row" v-if="globals && globals.acl && globals.acl.BuildingDetail && globals.acl.BuildingDetail.insertAction">
                    <div class="col-sm-12">
                        <div class="alert alert-warning" role="alert">
                            {{ $t('CSVTUTORIAL') }}
                        </div>
                        <b-form-fieldset v-bind:label="$t('FILECSVORXML')">
                            <inputvalidation :formerror="formUpload" name="file">
                                <b-form-file v-model="formUpload.file" :state="Boolean(formUpload.file)" :placeholder="$t('CHOOSEAFILE')" :drop-placeholder="$t('DROPFILEHERE')"></b-form-file>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center mt-lg mb-lg">
            <b-btn class="mr-2 btn-bis btn-cancel" @click="closeImport()">{{$t('CANCEL')}}</b-btn>
            <b-btn class="btn-bis btn-primary" v-on:click.prevent="importCSV(formUpload); $refs.csvimportmodal.hide();">{{$t('IMPORT')}}</b-btn>
        </div>
    </b-modal>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Api from '@/api/building_detail/BuildingDetail.js';
import CheckListItemsApi from '@/api/check_list/CheckListItems.js';
import BuildingDetailForm from './BuildingDetailForm.vue';

export default {
    name: 'BuildingDetail',
    components:
    {
        buildingdetailform: BuildingDetailForm,
    },
    data()
    {
        const me = this;

        me.formDataField = {
            clientName: '',
            address: '',
            city: '',
            postalCode: '',
            phone: '',
        };

        return {
            loading: true,
            formExport: {
                separator: ';',
                showHeaderFields: 1,
            },
            formUpload: {
                file: null,
            },
            data: {},
            checkListItems: {},
            formError: {},
            formData: {...me.formDataField},
            paginationSec: {
                clientName: null,
                address: null,
                city: null,
            },
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            searchTimeout: false,
            expandedItem: null,
            expandedViews: {},
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
    async changeStatus(isChecked, checkListItemId, buildingDetailId)
    {
        const me = this;
        await Api.itemChecked({ isChecked, checkListItemId, buildingDetailId });
        me.getData();
    },
        hideRow(item)
      {
          const me = this;
          delete me.expandedViews[item.buildingDetailId];
          me.$set(item, 'showAditionalData', false);
      },
      async showRow(item)
      {
          const me = this;
          me.expandedViews[item.buildingDetailId] = true;
          me.$set(item, 'showAditionalData', true);
      },
      async getData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }

              for (const item of data.root)
              {
                 if (me.expandedViews[item.buildingDetailId])
                 {
                    item.showAditionalData = true;
                 }
              }

              me.data = data;
          }
          catch (error)
          {
                console.log(error);
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async downloadCsv()
    {
        const me = this;
        try
        {
            const params = { ...me.getParams, ...me.formExport };
            const data = await Api.generateCsv(params);

            if (data.error === false)
            {
                Api.downloadCsv({ name: data.data });
            }
            else
            {
                me.$notify.notice(data);
                return;
            }
        }
        catch (error)
        {
            console.warn(error);
        }
    },
    async importCSV(formUpload)
    {
        const me = this;
        me.$store.commit('setModalAlert',
            {
                text: me.$i18n.t('AREYOUSHURE'),
                async btnAction()
                {
                    try
                    {
                        me.loading = true;
                        const data = await Api.importCSV(formUpload);

                        if (data.error === true && data.code === 'field_errors' && Array.isArray(data.errors)) {
                            const missingFields = data.errors
                                .filter(err => err.code === 'field_is_required' && err.params && err.params.field)
                                .map(err => me.$i18n.t(err.params.field.toUpperCase()));

                            if (missingFields.length > 0) {
                                const translatedCode = me.$i18n.t(data.code.toUpperCase());

                                const modifiedData = {
                                    ...data,
                                    notice: `${translatedCode}: ${missingFields.join(', ')}`
                                };

                                me.$notify.notice(modifiedData);
                            } else {
                                me.$notify.notice(data);
                            }
                        } else {
                            me.$notify.notice(data);
                        }
                        me.getData();
                    }
                    catch (error)
                    {
                        me.$notify.notice(error);
                    }
                    finally
                    {
                        me.loading = false;
                    }
                },
            });
    },
    closeImport()
    {
        const me = this;
        me.formUpload = {
            file: null,
        };
        me.$refs.csvimportmodal.hide();
    },
      async copy(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHUREYOUWANTTOCOPYSTEP'),
                  async btnAction()
                  {
                      const data = await Api.copy({id: id});
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
      },
      async deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  async btnAction()
                  {
                      const data = await Api.deleteRow({ id });
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
      },
      showModal(item)
      {
          const me = this;
          if (item == null)
          {
              item = {};
          }
          me.formData = { ...item };
      },
  },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination, ...me.paginationSec };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
